import { FaDoorOpen, FaBroom, FaClock } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCard({ summaryData, onClick, selectedKey = null }) {
    const summary = [
        {
            amount: summaryData?.totalRooms || 0,
            label: "Total Rooms",
            color: "text-black",
            icon: <FaDoorOpen size={20} className="text-blue-400" />,
            filter: "ALL",
        },
        {
            amount: summaryData?.cleanedRooms || 0,
            label: "Cleaned",
            color: "text-black",
            icon: <FaBroom size={20} className="text-teal-400" />,
            filter: "C",
        },
        {
            amount: summaryData?.uncleanedRooms || 0,
            label: "Pending",
            color: "text-black",
            icon: <FaClock size={20} className="text-orange-400" />,
            filter: "P",
        },
    ];

    return (
        <Wrapper>
            <ScrollCard style={{ scrollBehavior: "smooth" }}>
                {summary.map((item) => {
                    const selected = selectedKey === item.filter;
                    return (
                        <Card
                            key={item.label}
                            $selected={selected}
                            onClick={() => {
                                //onClick?.(item.filter)
                                if (selectedKey === item.filter) {
                                    onClick?.(null);
                                    return;
                                }
                                onClick?.(item.filter);
                            }}
                        >
                            <ValueRow>
                                {/* <IconWrap>{item.icon}</IconWrap> */}
                                <Value className={item.color}>{item.amount}</Value>
                            </ValueRow>
                            <Label>
                                {item.label}
                                <ArrowWrap>
                                    <Chevron />
                                </ArrowWrap>
                            </Label>
                        </Card>
                    );
                })}
            </ScrollCard>
        </Wrapper>
    );
}

export default SummaryCard;

// ---------------- Styled Components ----------------
const Wrapper = tw.div`w-full`;

const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;

const Card = tw.div`
  group min-w-[200px] cursor-pointer
  rounded-lg bg-white
  p-4
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected ? "border-primary-color shadow-md" : ""}
`;

const ValueRow = tw.div`flex items-center gap-1`;

const IconWrap = tw.div`
  flex items-center justify-center
  w-10 h-10 rounded-lg bg-gray-50
`;

const Value = tw.div`text-xl font-semibold text-gray-900`;

const Label = tw.div`
  flex mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;